import {
  Github,
  Globe,
  Instagram,
  Linkedin,
  Music2,
  Send,
  Twitch,
  Twitter,
  Youtube,
  Facebook,
  MessageCircle,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

export const SOCIAL_KEYS = [
  "x",
  "instagram",
  "tiktok",
  "youtube",
  "linkedin",
  "github",
  "discord",
  "telegram",
  "facebook",
  "spotify",
  "twitch",
] as const;

export type SocialKey = (typeof SOCIAL_KEYS)[number];

const ICONS: Record<string, LucideIcon> = {
  x: Twitter,
  instagram: Instagram,
  tiktok: Music2,
  youtube: Youtube,
  linkedin: Linkedin,
  github: Github,
  discord: MessageCircle,
  telegram: Send,
  facebook: Facebook,
  spotify: Music2,
  twitch: Twitch,
};

export const SOCIAL_LABELS: Record<string, string> = {
  x: "X / Twitter",
  instagram: "Instagram",
  tiktok: "TikTok",
  youtube: "YouTube",
  linkedin: "LinkedIn",
  github: "GitHub",
  discord: "Discord",
  telegram: "Telegram",
  facebook: "Facebook",
  spotify: "Spotify",
  twitch: "Twitch",
};

export function SocialLinks({ socials }: { socials: Record<string, string> | null | undefined }) {
  const entries = Object.entries(socials ?? {}).filter(([, v]) => Boolean(v));
  if (entries.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-2">
      {entries.map(([key, url]) => {
        const Icon = ICONS[key] ?? Globe;
        return (
          <a
            key={key}
            href={url}
            target="_blank"
            rel="noopener noreferrer nofollow"
            aria-label={SOCIAL_LABELS[key] ?? key}
            title={SOCIAL_LABELS[key] ?? key}
            className="flex size-9 items-center justify-center rounded-full border border-border bg-card text-muted-foreground transition-colors hover:border-primary hover:text-primary"
          >
            <Icon className="size-4" />
          </a>
        );
      })}
    </div>
  );
}
